import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";

import historyActions from "../../redux/history/action";
import authActions from "../../redux/auth/action";
import faqActions from "../../redux/faq/action";
import "./style.css";
import PageHead from "../../component/pageHead/PageHead";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import api from "../../config/api";
import { isNetworkRequestFailedError } from "../../config/helpers";

class FAQ extends Component {
  state = {
    faqFetched: false,
    faq: [],
    showLoader: false,
  };

  async componentDidMount() {
    const { history, setHistory, faq } = this.props;

    if (!faq.length) {
      this.fetchFaq();
    }

    setHistory(history);
  }

  fetchFaq = async () => {
    const { setFaq, setAlertMessage } = this.props;

    try {
      this.setState({ showLoader: true });

      const response = await api.fetchFaq();

      setFaq(response.data.result);

      this.setState({
        faq: response.data.result,
        showLoader: false,
      });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchFaq : null,
      });
    }
  };

  render() {
    const { showLoader } = this.state;
    const { faq } = this.props;

    return (
      <Container>
        <PageHead containerStyles={{ width: "100%" }} title="FAQs" />
        {!!faq.length && (
          <div className="faq-container">
            {faq.map((val, i) => {
              return (
                <div key={i}>
                  <h5>{val.question}</h5>
                  <p>{val.answer}</p>
                  <div className="faq-border-line" />
                </div>
              );
            })}
          </div>
        )}
        {showLoader && <CustomLoader loadingText="Fetching FAQs" />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  faq: state.faq.faq,
});

const mapDispatchToProps = {
  setHistory: historyActions.setHistory,
  setFaq: faqActions.setFaq,
  setAlertMessage: authActions.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(FAQ);
